/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {LibraryCreativeLinkCreativeModalComponent, LibraryCreativeLinkCreativeModalResult} from './library-creative-link-creative-modal.component';

export interface LibraryCreativeLinkCreativeModalOptions {
  model: any;
  modelComms?: any;
  onComplete?: (result: LibraryCreativeLinkCreativeModalResult) => void;
}

@Injectable({providedIn: 'root'})
export class LibraryCreativeLinkCreativeModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: LibraryCreativeLinkCreativeModalOptions): void {
    this.angularModalService.show(LibraryCreativeLinkCreativeModalComponent, {
      initialState: options
    });
  }
}
